'use strict';

angular.module('app').directive('lazyLoad', function($window, $timeout) {
    var link = function(scope, element) {
        $(element).on('display', function(e) {
            console.log('he', $(this).attr('style'));
        });
    };
    return {
        restrict: 'A',
        scope: {
            lazyLoad: '@'
        },
        link: link
    };
});